import React from 'react';
import { graphql } from '@apollo/client/react/hoc';
import gql from 'graphql-tag';
import { Empty, Spin } from 'antd';

import { compose } from '../../../core';
import { getIntFromString } from '../functions';
import { withLookSurveyFilterUpdating, withLookSurveyState } from '../../containers/LookOperations';

import SelectField from './SelectField';

export const ALL_SURVEY_QUERY = gql`
  query allSurveysForTokens($first: Int, $orderBy: [String], $name_Icontains: String) {
    allSurveysForTokens(first: $first, orderBy: $orderBy, name_Icontains: $name_Icontains) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

const SurveyAutoComplete = props => {
  const { loading, allSurveysForTokens, margin, onNameChange, onFiltersRemove } = props;
  const handleFilterRemove = React.useRef(() => {});

  handleFilterRemove.current = () => {
    onFiltersRemove();
  };

  React.useEffect(() => {
    return () => handleFilterRemove.current();
  }, []);

  const choices =
    !loading &&
    allSurveysForTokens &&
    allSurveysForTokens.edges.length > 0 &&
    allSurveysForTokens.edges.map(({ node }) => ({
      label: node.name,
      value: getIntFromString(node.id)
    }));

  return (
    <SelectField
      margin={margin}
      showSearch
      choices={choices}
      style={{ width: !margin && 200, marginBottom: !margin && 0 }}
      // labelInValue
      filterOption={false}
      onSearch={onNameChange}
      notFoundContent={
        loading ? (
          <div align="center">
            <Spin size="small" />
          </div>
        ) : (
          <Empty />
        )
      }
      {...props}
    />
  );
};

export default compose(
  withLookSurveyState,
  graphql(ALL_SURVEY_QUERY, {
    options: ({ filter, orderBy }) => {
      return { variables: { ...filter, orderBy } };
    },
    props({ data }) {
      const { loading, error, allSurveysForTokens, subscribeToMore, updateQuery } = data;
      return { loading, error, allSurveysForTokens, subscribeToMore, updateQuery };
    }
  }),
  withLookSurveyFilterUpdating
)(SurveyAutoComplete);
